export default {
  lista: [],
  funilVendas: {},
  colunasFunilVendas: [],
  colunasPadraoFunil: ['NP', 'WCI', 'WRTFL', 'WRAP', 'OAT', 'OA'],
  estaCarregando: false,
  order: '',
  direcao: '',
  paginaAtual: 1,
  totalItens: null,
  todosItensCarregados: false,
  itemSelecionadoID: null,
  pessoa_indicou: null,
  pessoa_indicou_nome: null,



  filtros: {
    manterFiltros: false,
    nome: null,
    telefone: null,
    busca: '',
    idade: null,
    idioma: null,
    consultor: null,
    tipo_lead:null,
    data_cadastro_de: null,
    data_cadastro_ate: null,
    data_proximo_contato_de: null,
    data_proximo_contato_ate: null,
    horario_proximo_contato_de: null,
    horario_proximo_contato_ate: null,
    data_validade_promocao_de: null,
    data_validade_promocao_ate: null,
    situacao: null,
    data_agendamento: null,
    consultor_comercial: null,
    pessoa_indicou: null,
    pessoa_indicou_nome: null
  },
  parametros: {
      idioma: null,
      consultor: null,
      idade: null,
      nome: null,
      periodo_pretendido: null,
      email: null,
      etapaFunilFiltroRapido:null,
      tipo_lead:null,
      situacao:null,
      data_cadastro_de: null,
      data_cadastro_ate: null,
      data_proximo_contato_de: null,
      data_proximo_contato_ate: null,
      data_validade_promocao_de: null,
      data_validade_promocao_ate: null,
      horario_proximo_contato_de: null,
      horario_proximo_contato_ate: null,
   },

  itemSelecionado: {
    grau_interesse: null,
    data_proximo_contato: null,
    data_primeiro_atendimento: null,
    horario_proximo_contato: null,
    consultor_funcionario: null,
    consultor_responsavel_funcionario: null,
    workflow: {},
    idiomas: null,
    franqueada: null,
    aluno: null,
    nome: '',
    idade: null,
    tipo_lead: null,
    tipo_contato: null,
    tipo_prospeccao: null,
    email_contato: null,
    email_secundario: null,
    telefone_contato: null,
    telefone_secundario: null,
    sexo: null,
    periodo_pretendido: null,
    curso: null,
    data_validade_promocao: null,
    interessadoAtividadeExtras: [],
    workflow_acao: {},
    pessoa_indicou: null,
    pessoa_indicou_nome: null
  }
}
